module.exports = __webpack_public_path__ + "static/img/menu1.65e02410.png";